export default "__VITE_ASSET__CWgrl24o__"